export interface CsvError {
  code: string;
  message: string;
  description?: string;
}

export const csvErrorCodes: Record<string, CsvError> = {
  "A2-101": {
    code: "A2-101",
    message: "Unsupported CSV encoding format",
    description: "The CSV file encoding format is not supported. Please save the file in UTF-8 format and try again."
  },
  "A2-102": {
    code: "A2-102", 
    message: "Database connection failed during storage",
    description: "Failed to connect to the database. Please wait a moment and try again."
  },
  "A2-103": {
    code: "A2-103",
    message: "Client not registered in database during storage", 
    description: "The client is not registered in the database. Please contact the administrator."
  },
  "A2-104": {
    code: "A2-104",
    message: "File not found during storage",
    description: "The specified file was not found. Please verify that the file has not been deleted."
  },
  "A2-100": {
    code: "A2-100",
    message: "Unexpected error during storage",
    description: "An unexpected error occurred. Please contact the administrator."
  },
  "U4-101": {
    code: "U4-101",
    message: "CSV storage processing error",
    description: "An error occurred while processing the CSV file."
  },
  "U4-100": {
    code: "U4-100", 
    message: "Unexpected error during storage",
    description: "An unexpected error occurred. Please contact the administrator."
  },
  "R2-101": {
    code: "R2-101",
    message: "CSV reading error",
    description: "An error occurred while reading the CSV file."
  },
  "R2-102": {
    code: "R2-102",
    message: "CSV reading error",
    description: "An error occurred while reading the CSV file."
  },
  "U7-100": {
    code: "U7-100",
    message: "CSV data format error",
    description: "The datetime data format is invalid. Please use the correct format (e.g., 2023/01/01)."
  }
};

export function getCsvErrorByCode(code: string): CsvError | null {
  return csvErrorCodes[code] || null;
}